<template>
  <div class="rsvp-report-box">
    <div class="rsvp-report">
      <div class="form-group">
        <div class="instruction">Please select a start and end date:</div>
        <div class="row expanded">
          <div class="small-6 column padding-R">
            <div class="date-input">
              <label>Start Date:</label>
              <datepicker class="datepicker" v-model="from" format="MMMM dd, yyyy" :highlighted="highlightedDates"></datepicker>
            </div>
          </div>
          <div class="small-6 column padding-L">
            <div class="date-input">
              <label>End Date:</label>
              <datepicker class="datepicker" v-model="to" format="MMMM dd, yyyy" :highlighted="highlightedDates"></datepicker>
            </div>
          </div>
        </div>
        <div class="instruction">License Type:</div>
        <div class="row expanded">
          <div class="small-12 column">
            <select v-model="driverType" class="driver-type">
              <option value="tnc">TNC</option>
              <option value="tcp">TCP</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="list-box">
      <div class="rsvp-report">
        <div class="form-group">
          <div class="instruction">Please select the reports to generate:</div>
          <div class="row expanded reports">
            <div :class="['small-12 column report', reportStatus.activeDrivers, {'processing':csv.loading}]">
              <label class="checkbox">
                <input type="checkbox" v-model="selectedReports.activeDrivers" />
                <span>{{ reportLabel('activeDrivers') }}</span>
              </label>
            </div>
          </div>
        </div>

        <transition name="slide-down">
          <div class="error" v-show="error.show">
            <span v-show="!!error.message">{{ error.message }}</span>
            <ul v-show="error.empty.length">
              <li>Empty Result:</li>
              <li v-for="(empty, i) in error.empty" :key="i">- {{ empty }}</li>
            </ul>
          </div>
        </transition>
        <a :class="['button cta success small block', {disabled: csv.loading}]"
          href="javascript:;" @click="startProcess">
          <i class="fa fa-spinner fa-spin" v-show="csv.loading"></i>
          <span v-show="!csv.loading">Generate and Download Report</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
// import jsPDF from 'jspdf'
// import html2canvas from 'html2canvas'
import datepicker from 'vuejs-datepicker'
import CsvExport from 'csvexport'
// import featureToggle from '@/modules/api/featureToggle'
export default {
  name: 'active-driver-report',
  components: { datepicker },
  data () {
    return {
      from: null,
      to: null,
      driverType: 'tnc',
      error: {
        show: false,
        message: '',
        empty: []
      },
      selectedReports: {
        activeDrivers: true
      },
      reportStatus: {
        activeDrivers: ''
      },
      csv: {
        title: '',
        date: '',
        label: [],
        data: [],
        list: [],
        total: {},
        loading: false
      },
    }
  },
  computed: {
    show () { return this.$store.state.reports.rsvpReport.show },
    highlightedDates () {
      let self = this
      let result = { to: null, from: null }
      if (self.from !== null) { result.from = self.from }
      if (self.to !== null) { result.to = self.to }
      return result
    },
  },
  methods: {
    isValid () {
      let self = this
      self.error.show = false
      self.error.empty = []
      if (self.from === null || self.to === null) {
        self.error.show = true
        self.error.message = 'Please specify the Start and End dates.'
        return false
      }

      let start = moment(this.from)
      let end = moment(this.to)
      if (end.diff(start, 'days') > 30) {
        self.error.show = true
        self.error.message = 'Cannot generate report more than 31 days.'
        return false
      }

      if (!self.selectedReports.activeDrivers) {
        self.error.show = true
        self.error.message = 'Please select at least one report type.'
        return false
      }
      return true;
    },
    startProcess () {
      if (!this.isValid()) { return }
      this.csv.list = []
      for (let report in this.selectedReports) {
        if (this.selectedReports[report]) {
          this.reportStatus[report] = 'on-queue'
          this.csv.list.push(report)
        }
      }
      this.csv.loading = true
      this.generateReport()
    },
    generateReport () {
      if (!this.csv.list.length) {
        this.csv.loading = false
        return
      }
      console.log('Processing:', this.csv.list[0])
      this.getDataReports(this.csv.list[0])
    },
    getDataReports (type) {
      let self = this
      self.reportStatus[type] = 'loading'
      self.$sdk.get(self.apiParams(type).url, self.apiParams(type).data, r => {
        // console.log('---', r)
        // return
        if (r.error) {
          self.reportStatus[type] = 'has-error'
          return
        }
        self.setPdfLabel(type)
        // self.pdf.table.data = {}
        // self.pdf.table.extra = {}
        // self.pdf.table.total = {}
        self.csv.data = []
        self.csv.total = {}
        if (Object.keys(r.list).length > 0) {
          self.buildData(type, r.list)
        } else {
          self.error.show = true
          self.error.empty.push(self.reportLabel(type))
          self.reportStatus[type] = 'has-error'
          self.csv.list.shift()
          self.generateReport()
        }
      })
    },
    apiParams (type) {
      let url = ''
      let start = moment(this.from)
      let end = moment(this.to)
      let data = {
        token: this.$store.state.session.sessionToken,
        since: start.format('YYYY-MM-DD'),
        until: end.format('YYYY-MM-DD')
      }
      switch (type) {
        case 'activeDrivers':
          url = '/reports/activedrivers'
          data.licenseType = this.driverType
          break
      }
      return { url: url, data: data }
    },
    setPdfLabel (type) {
      let start = moment(this.from)
      let end = moment(this.to)
      let dateRange = `${start.format('MM/DD/YYYY')} - ${end.format('MM/DD/YYYY')}`
      if (type === 'activeDrivers') {
        this.csv.title = 'Opoli Active Drivers Reports'
        this.csv.date = `(${dateRange})`
        this.csv.label = ['ID', 'Vehicle Number', 'Email', 'Name', 'Availability', 'License']

        end.add(1, 'days')
        for (let m = moment(start); m.isBefore(end); m.add(1, 'days')) {
          this.csv.label.push(m.format('MM-DD-YYYY'))
        }
        this.csv.label.push('RSVP Completed')
        this.csv.label.push('RSVP No Show')
        this.csv.label.push('Driver Payment')
      }
    },
    buildData (type, csvData) {
      let self = this
      let totalPayment = 0
      let start = moment(this.from)
      let end = moment(this.to)
      end.add(1, 'days')

      for (var i in csvData) {
        let driverData = {
          ID: csvData[i].driverId,
          'Vehicle Number': csvData[i].driverNum,
          Email: csvData[i].email,
          Name: csvData[i].name,
          Availability: csvData[i].preferredTime,
          License: self.driverType,
        }
        for (let m = moment(start); m.isBefore(end); m.add(1, 'days')) {
          driverData[m.format('MM-DD-YYYY')] = csvData[i].days[m.format('YYYY-MM-DD')] || 0
        }
        driverData['RSVP Completed'] = csvData[i].completed
        driverData['RSVP No Show'] = csvData[i].noshow
        driverData['Driver Payment'] = csvData[i].payout.toFixed(2)
        totalPayment += parseFloat(csvData[i].payout.toFixed(2)) || 0
        self.csv.data.push(driverData)
      }
      self.csv.data.sort((a, b) => (a['RSVP Completed'] > b['RSVP Completed']) ? -1 : ((b['RSVP Completed'] > a['RSVP Completed']) ? 1 : 0))
      self.csv.total.drivers = Object.keys(csvData).length
      self.csv.total.payment = totalPayment.toFixed(2)
      self.processCsv(type)
    },
    fileName (type, format) {
      let start = moment(this.from)
      let end = moment(this.to)
      let timestamp = start.format('YYYYMMDD') + '_' + end.format('YYYYMMDD')
      switch (type) {
        case 'activeDrivers': return 'reports-ActiveDrivers_' + timestamp + '.' + format
      }
    },
    resetSelectedStatus () {
      this.selectedReports = {
        activeDrivers: false
      }
    },
    resetReportStatus () {
      this.error.show = false
      this.error.empty = []
      this.reportStatus = {
        activeDrivers: ''
      }
    },
    reportLabel (type) {
      switch (type) {
        case 'activeDrivers': return 'Active Drivers Report'
      }
    },
    processDownloads (action, data) {
      if (action === 'pdf' && this.pdfChecked) {
        this.processPdf(data.type, data.page)
      } else if (action === 'csv' && this.csvChecked) {
        this.processCsv(data.type)
      } else {
        this.generateReport()
      }
    },
    processCsv (type) {
      const exporter = CsvExport.create({
        filename: this.fileName(type, 'csv'),
        columns: this.csv.label
      })
      // add total
      this.csv.data.push({})
      this.csv.data.push(this.buildCsvTotal(type))
      exporter.downloadCsv(this.csv.data)
      this.reportStatus[type] = 'success'
      this.csv.list.shift()
      this.generateReport(true)
    },
    buildCsvTotal (type) {
      let csvData = {}
      if (type === 'activeDrivers') {
        csvData[this.csv.label[0]] = ''
        csvData[this.csv.label[1]] = `Total Drivers (${this.csv.total.drivers})`
        csvData[this.csv.label[2]] = `Total Driver Payment (${this.csv.total.payment})`
        csvData[this.csv.label[3]] = ''
        csvData[this.csv.label[4]] = ''
        csvData[this.csv.label[5]] = ''
        csvData[this.csv.label[6]] = ''
        csvData[this.csv.label[7]] = ''
        csvData[this.csv.label[8]] = ''
      }
      return csvData
    },
    formatCheck () {
      this.error.show = false
      this.formatError = false
    },
  },
  watch: {
    show (value) {
      if (!value) { return }
      this.from = null
      this.to = null
      this.error.show = false
      this.error.empty = []
      this.resetSelectedStatus()
      this.resetReportStatus()
    },
    from (value) { this.resetReportStatus() },
    to (value) { this.resetReportStatus() },
    'selectedReports.activeDrivers' (value) { this.resetReportStatus() },
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.rsvp-report-box {
  transform-origin: top center;
  position: relative;
  width: 100%;
}
.driver-type{
  padding: 5px;
}
.rsvp-report {
  border-radius: 3px;
  padding: 0 20px 20px;
  & .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 20px;
    font-size: 18px;
  }
  & .date-input {
    margin-bottom: 10px;
    & label {
      font-size: 13px;
      color: #999;
      display: block;
    }
    select{
      padding: 10px;
      height: 46px;
      outline: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      border-color: #cacaca;
      font-size: 14px;
      color: #333;
      background-image: url('/assets/img/dropdown-arrow.png');
      background-repeat: no-repeat;
      background-position: right 50%;
      &[disabled]{ background-color: #ebebe4; }
    }
  }
  .reports{
    max-height: 350px;
    margin-bottom: 10px;
    overflow: auto;
    clear: both;
    background: #fafafa;
    border: 1px solid #ddd;
    position: relative;
    .report{
      position: relative;
      z-index: 1;
      &:hover{ background:#f1f1f1; }
      &.processing{
        background: rgba(0,0,0, .7);
        input{ opacity: .5; }
      }
      select{
        margin-left: 28px;
        margin-bottom: 10px;
        width: calc(100% - 43px);
        border-color: #999;
        font-size: 13px;
        color: #333;
        padding: 3px 5px;
        transition: all .2s ease;
        &.disabled{
          background: #fafafa;
          border-color: #ccc;
        }
        option:disabled{ background: #eaeaea; }
      }
      &.on-queue, &.loading, &.has-error, &.success{
        z-index: 3;
        box-shadow: 0 0 2px rgba(0,0,0, .4);
      }
      &.on-queue{ background: #fff; }
      &.loading{
        color: #775913;
        background: #f1ce7e;
      }
      &.success{
        color: #0f693a;
        background: #a9f7ce;
      }
      &.has-error{
        color: #b93030;
        background: #fbb0b0;
      }
    }
  }
}
.filter{
  list-style: none;
  margin: 0 0 5px;
  padding: 0;
  font-size: 13px;
  display: flex;
  li{
    margin: 2px 0;
    width: 100%;
  }
  label{ cursor: pointer;}
  input{
    display: inline-block;
    margin: 0 3px 0 0;
    width: auto;
    vertical-align: middle;
  }
}

.list-box{
  overflow: hidden;
  position: relative;
  padding-bottom: 20px;
}
.error {
  background-color: #F25E0D;
  font-size: 14px;
  text-align: center;
  color: #fff;
  border-radius: 3px;
  padding: 5px;
  margin-bottom: 15px;
  transform-origin: top center;
  ul{
    list-style: none;
    margin: 0;
    padding: 10px;
    text-align: left;
    li:first-child{
      font-weight: 600;
      font-size: 14px;
      line-height: 1;
      margin-bottom: 2px;
    }
    li{
      font-size: 13px;
    }
  }
}
.form-group {
  display: block;
  & .instruction {
    margin-bottom: 5px;
    font-size: 14px;
    font-weight: 600;
    color: #777;
  }
}
.checkbox {
  display: block;
  font-size: 13px;
  cursor: pointer;
  padding: 5px 10px;

  &.sub{
    padding-left: 30px;
    margin-bottom: 10px;
  }
  & > * {
    display: inline-block;
    vertical-align: middle;
    margin: 0;
    width: auto;
  }
  input { margin-right: 3px; }
}
.padding-R { padding-right: 7px; }
.padding-L { padding-left: 7px; }
#pdf-view{
  position: absolute;
  top: 100%;
  left: 0;
  width: 793px;
  height: 1122px;
  background: #fff;
  .page{
    padding: 30px 40px 30px 30px;
    position: relative;
    width: 100%;
    height: 100%;
    .page-count{
      position: absolute;
      bottom: 10px;
      right: 30px;
      color: #aaa;
      font-size: 12px;
      text-align: right;
      font-style: italic;
    }
  }
  .title{
    text-align: center;
    font-weight: 600;
    font-size: 21px;
  }
  .date-range{
    text-align: center;
    font-style: italic;
    font-size: 18px;
    margin-bottom: 20px;
    color: #555;
  }
  table{
    width: 100%;
    font-size: 12px;
    border-collapse: collapse;
    thead{
      font-weight: 600;
      tr:last-child th{ border-bottom: 1px solid #333; }
    }
    tbody{
      tr{
        &.subtotal, &.total{ font-weight: 700; }
        &.total{
          color: #000;
          font-size: 12px;
        }
      }
      td{ padding: 2px 3px; }
    }
  }
}
.report-active-drivers{
  width: 1122px!important;
  height: 793px!important;
  table{
    tbody tr.total{
      border-top: 1px solid #333;
      font-weight: 600;
      font-size:12.5px
    }
    .provId, .provName, .sectorId, .runId, .rsvpId, .accepted, .timeQueue, .service, .date{ text-align: center; }
  }
}

.slide-down-enter-active, .slide-down-leave-active { transition: all .3s ease; }
.slide-down-enter, .slide-down-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Reports/ActiveDriverReport.vue